import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const errors = {
	state: {
		totales: '',
		validaciones: [],
		estadosValidacion: {},
		tutoradas: [],
		asignaciones: [],
		documentos: [],
		loading: false,
		loadingHistorico: false
	},
	getters: {
		getTotales: state => state.totales,
		getTutoradas: state => state.tutoradas,
		getTutoradasAnioAcademico: state => state.tutoradas.filter(e => e.idAnioAcademico >= e.idAnioAcademicoActual),
		getTutoradasPorEstados: state => {
			let tutoradas = new Object();
			if (state.tutoradas.length > 0) {
				tutoradas['en-curso'] = state.tutoradas.filter(e => e.idAnioAcademico >= e.idAnioAcademicoActual && (e.evaluadaPorTutor == null || e.evaluadaPorTutor == false) && (e.fin_practica_eval_tutor_empresarial != true || e.fin_practica_eval_satisfaccion != true));
				tutoradas['en-evaluacion'] = state.tutoradas.filter(e => e.idAnioAcademico >= e.idAnioAcademicoActual && (e.evaluadaPorTutor == null || e.evaluadaPorTutor == false) && (e.fin_practica_eval_tutor_empresarial == true && e.fin_practica_eval_satisfaccion == true));
				tutoradas['evaluados'] = state.tutoradas.filter(e => e.idAnioAcademico >= e.idAnioAcademicoActual && e.evaluadaPorTutor == true);
			}
			return tutoradas;
		},
		getTutoradasHistorico: state => state.tutoradas.filter(e => e.idAnioAcademico < e.idAnioAcademicoActual),
		getTutoradasHistoricoPorEstados: state => {
			let tutoradas = new Object();
			if (state.tutoradas.length > 0) {
				tutoradas['en-curso'] = state.tutoradas.filter(e => e.idAnioAcademico < e.idAnioAcademicoActual && (e.evaluadaPorTutor == null || e.evaluadaPorTutor == false) && (e.fin_practica_eval_tutor_empresarial != true || e.fin_practica_eval_satisfaccion != true));
				tutoradas['en-evaluacion'] = state.tutoradas.filter(e => e.idAnioAcademico < e.idAnioAcademicoActual && (e.evaluadaPorTutor == null || e.evaluadaPorTutor == false) && (e.fin_practica_eval_tutor_empresarial == true && e.fin_practica_eval_satisfaccion == true));
				tutoradas['evaluados'] = state.tutoradas.filter(e => e.idAnioAcademico < e.idAnioAcademicoActual && e.evaluadaPorTutor == true);
			}
			return tutoradas;
		},

		getValidaciones: state => state.validaciones,
		getValidacionesPorEstados: state => {
			let validaciones = new Object();
			if (state.validaciones.length > 0) {
				validaciones['pendientes'] = state.validaciones.filter(e => e.idEstadoValidacion == 1);
				validaciones['validadas'] = state.validaciones.filter(e => e.idEstadoValidacion == 2);
				validaciones['rechazadas'] = state.validaciones.filter(e => e.idEstadoValidacion == 3);
			}
			return validaciones;
		},

		getAsignaciones: state => state.asignaciones,
		getAsignacionesAnioAcademico: state => state.asignaciones.filter(e => e.idAnioAcademico >= e.idAnioAcademicoActual),
		getAsignacionesPorEstados: state => {
			let asignaciones = new Object();
			if (state.asignaciones.length > 0) {
				asignaciones['pendientes'] = state.asignaciones.filter(e => e.idAnioAcademico >= e.idAnioAcademicoActual && e.idTutorAcademico == null);
				asignaciones['realizadas'] = state.asignaciones.filter(e => e.idAnioAcademico >= e.idAnioAcademicoActual && e.idTutorAcademico != null);
			}
			return asignaciones;
		},
		getAsignacionesHistorico: state => state.asignaciones.filter(e => e.idAnioAcademico < e.idAnioAcademicoActual),
		getAsignacionesHistoricoPorEstados: state => {
			let asignaciones = new Object();
			if (state.asignaciones.length > 0) {
				asignaciones['pendientes'] = state.asignaciones.filter(e => e.idAnioAcademico < e.idAnioAcademicoActual && e.idTutorAcademico == null);
				asignaciones['realizadas'] = state.asignaciones.filter(e => e.idAnioAcademico < e.idAnioAcademicoActual && e.idTutorAcademico != null);
			}
			return asignaciones;
		},

		getDocumentos: state => state.documentos,
		getLoading: (state) => {
			return state.loading;
		},
		getLoadingHistorico: (state) => {
			return state.loadingHistorico;
		}

	},
	actions: {
		requestTotales: ({ commit, dispatch }) => {

			if (!!axios.defaults.headers.get.authorization) {

				return new Promise((resolve, reject) => {
					axios.get('/api/TutorAcademico/dameTotales').then(response => {
						if (response.data.status == 0) {
							commit('setTotales', response.data.datos);
							resolve(true);
						} else {
							commit('setError', response.data.status);
						}
					})
						.catch(function (error) {
							reject(false);
							dispatch('sendErrorServer', error.response);
						});
				});

			}
		},
		requestEstadosValidacion: ({ commit, dispatch }) => {

			return new Promise((resolve, reject) => {
				axios.get('/api/Dominios/estadosValidacionPracticas').then(response => {
					if (response.data.status == 0) {
						commit('setEstadosValidacion', response.data.datos);
						resolve(true);
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestValidaciones: ({ commit, dispatch }) => {

			return new Promise((resolve, reject) => {
				axios.get('/api/TutorAcademico/damePracticasAvalidar').then(response => {
					if (response.data.status == 0) {
						if (!!response.data.datos) {
							commit('setValidaciones', response.data.datos);
						}
						resolve(true);
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestTutoradas: ({ commit, dispatch }) => {
			return new Promise((resolve, reject) => {
				axios.get('/api/TutorAcademico/damePracticasTutoradas').then(response => {
					if (response.data.status == 0) {
						if (!!response.data.datos) {
							commit('setTutoradas', response.data.datos);
						}
						resolve(true);
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestAsignaciones: ({ commit, dispatch }) => {
			commit('loading')
			return new Promise((resolve, reject) => {
				axios.get('/api/TutorAcademico/damePracticasAsignadas').then(response => {
					if (response.data.status == 0) {
						if (!!response.data.datos) {
							commit('setAsignaciones', response.data.datos);
						}
						resolve(true);
					} else {
						commit('setError', response.data.status);
					}
					commit('endLoad')
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestTutoradasHistorico: ({ commit, dispatch }, idAnioAcademico) => {
			return new Promise((resolve, reject) => {
				axios.get('/api/TutorAcademico/damePracticasTutoradasHistorico/' + idAnioAcademico).then(response => {
					if (response.data.status == 0) {
						if (!!response.data.datos) {
							commit('setTutoradasHistorico', response.data.datos);
						}
						resolve(true);
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestAsignacionesHistorico: ({ commit, dispatch }, idAnioAcademico) => {
			commit('loadingHistorico')
			return new Promise((resolve, reject) => {
				axios.get('/api/TutorAcademico/damePracticasAsignadasHistorico/' + idAnioAcademico).then(response => {
					if (response.data.status == 0) {
						if (!!response.data.datos) {
							commit('setAsignacionesHistorico', response.data.datos);
						}
						resolve(true);
					} else {
						commit('setError', response.data.status);
					}
					commit('endLoadHistorico')
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestPractica: ({ commit, dispatch }, id) => {

			const token = window.localStorage.getItem("_token");
			axios.defaults.headers.get['authorization'] = `Bearer ${token}`;

			return new Promise((resolve, reject) => {

				axios.get('/api/TutorAcademico/dameDetallePractica/' + id).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestDocumentos: ({ commit, getters, dispatch }) => {
			axios.get(`/api/Dominios/tiposDocumentoAlumnoPracticas`).then(response => {
				(response.data.status == 0) ? commit('setDocumentos', response.data.datos) : '';
			})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
		},
		cambiaEstadoPractica: ({ commit, dispatch }, data) => {

			if (!!!data.fichero.ficheroB64) {
				data.fichero = null;
			}

			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/cambiaEstadoPractica', data).then(response => {
					if (response.data.status == 0) {
						commit('setError', 502);
						commit('changePracticaStatus', data);
						resolve(true);
						dispatch('requestTotales');
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		annadirObservacionManual: ({ commit, dispatch }, data) => {

			if (!!!data.fichero.ficheroB64) {
				data.fichero = null;
			}

			data.observacion = data.observacion.replaceAll("\n", '<br>');

			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/annadirObservacionManual', data).then(response => {
					if (response.data.status == 0) {
						commit('setError', 508);
						resolve(true);
						//dispatch('requestTotales');
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		marcarEvaluada({ commit, dispatch }, id) {
			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/marcarComoEvaluada/' + id).then(response => {
					if (response.data.status == 0) {
						resolve(true);
						commit('setError', 501);
						commit('changeEvaluacion', id);
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		marcarEvaluacionPendiente({ commit, dispatch }, id) {
			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/marcarComoEvaluacionPendiente/' + id).then(response => {
					if (response.data.status == 0) {
						resolve(true);
						commit('setError', 503);
						commit('changeEvaluacion', id);
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		dameContestacionEncuesta({ commit, dispatch }, id) {
			return new Promise((resolve, reject) => {
				axios.get('/api/TutorAcademico/dameContestacionEncuenstaPracticas/' + id).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		addDocumentoPractica({ commit }, data) {

			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/' + data.type, data.request).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					} else {
						reject(false);
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestPosiblesTutoresPractica: ({ commit, dispatch }, id) => {

			if (!!axios.defaults.headers.get.authorization) {

				return new Promise((resolve, reject) => {
					axios.get('/api/TutorAcademico/damePosiblesTutoresPractica/' + id).then(response => {
						if (response.data.status == 0) {
							resolve(response.data.datos);
						} else {
							commit('setError', response.data.status);
						}
					})
						.catch(function (error) {
							reject(false);
							dispatch('sendErrorServer', error.response);
						});
				});

			}
		},
		cambiarTutorAcademicoPractica: ({ commit, dispatch }, data) => {
			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/cambiarTutorAcademicoPractica', data).then(response => {
					if (response.data.status == 0) {

						//CAMBIO EL TUTOR PARA QUE SE MUEVA DE LISTADO ASIGNACIONES PENDIENTES A REALIZADAS
						var dataCambiarEstadoPractica = {idPractica: data.idPractica, idTutor: response.data.datos};
						commit('changePracticaAsignacionStatus', dataCambiarEstadoPractica);

						commit('setError', 506);

						resolve(true);

					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		guardarNuevoTutorAcademicoPractica: ({ commit, dispatch }, data) => {
			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/guardarNuevoTutorAcademicoPractica', data).then(response => {
					if (response.data.status == 0) {

						//CAMBIO EL TUTOR PARA QUE SE MUEVA DE LISTADO ASIGNACIONES PENDIENTES A REALIZADAS
						var dataCambiarEstadoPractica = {idPractica: data.idPractica, idTutor: response.data.datos};
						commit('changePracticaAsignacionStatus', dataCambiarEstadoPractica);

						commit('setError', 507);

						resolve(true);

					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		eliminarTutorAcademicoPractica: ({ commit, dispatch }, data) => {
			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/eliminarTutorAcademicoPractica', data).then(response => {
					if (response.data.status == 0) {

						//CAMBIO EL TUTOR PARA QUE SE MUEVA DE LISTADO ASIGNACIONES REALIZADAS A PENDIENTES
						var dataCambiarEstadoPractica = {idPractica: data.idPractica, idTutor: response.data.datos};
						commit('changePracticaAsignacionStatus', dataCambiarEstadoPractica);

						commit('setError', 513);

						resolve(true);

					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		cambiarTutorEmpresaPractica: ({ commit, dispatch }, data) => {
			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/cambiarTutorEmpresaPractica', data).then(response => {
					if (response.data.status == 0) {
						commit('setError', 509);
						resolve(true);

					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		editObservacionPractica: ({ commit, dispatch }, data) => {
			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/editObservacionPractica', data).then(response => {
					if (response.data.status == 0) {
						commit('setError', 515);
						resolve(true);

					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		eliminarDocumentoPractica: ({ commit, dispatch }, data) => {
			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/eliminarDocumentoPractica', data).then(response => {
					if (response.data.status == 0) {
						commit('setError', 514);
						resolve(true);

					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		cambiarEspecialidadTitulacion: ({ commit, dispatch }, data) => {
			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/cambiarEspecialidadTitulacion', data).then(response => {
					if (response.data.status == 0) {
						commit('setError', 510);
						resolve(true);

					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		solicitarCuestionario({ commit, dispatch }, data) {
			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/solicitarCuestionario', data).then(response => {
					if (response.data.status == 0) {
						commit('setError', 511);
					} else {
						commit('setError', 512);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		dameMailsInteresTutor: ({ commit, dispatch }) => {
			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/dameMailsInteresTutor').then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);

					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		dameEncuestasInteresTutor: ({ commit, dispatch }) => {
			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/dameEncuestasInteresTutor').then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);

					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		dameOfertasDeTitulacionCoordinadorPractica: ({ commit, dispatch }) => {
			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/dameOfertasDeTitulacionCoordinadorPractica').then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);

					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestOfertaTutor: ({ commit, dispatch }, id) => {

			const token = window.localStorage.getItem("_token");
			axios.defaults.headers.get['authorization'] = `Bearer ${token}`;

			return new Promise((resolve, reject) => {

				axios.get('/api/TutorAcademico/dameDetalleOfertaPublicada/' + id).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
	},
	mutations: {
		setTotales: function (state, totales) {
			state.totales = totales
		},
		setValidaciones: function (state, practicas) {
			state.validaciones = practicas
		},
		setEstadosValidacion: function (state, estados) {
			state.estadosValidacion = estados
		},
		setTutoradas: function (state, practicas) {
			state.tutoradas = practicas
		},
		setAsignaciones: function (state, practicas) {
			state.asignaciones = practicas
		},
		setTutoradasHistorico: function (state, practicas) {
			//Aqui lo que tenemos que hacer es quitar todas las que teniamos en historico y poner las que nos acabamos de traer por historico
			state.tutoradas = state.tutoradas.filter(x => !x.esDeHistorico_PortalTutor);
			practicas.forEach(e => {
				state.tutoradas.push(e);
			});
		},
		setAsignacionesHistorico: function (state, practicas) {
			//Aqui lo que tenemos que hacer es quitar todas las que teniamos en historico y poner las que nos acabamos de traer por historico
			state.asignaciones = state.asignaciones.filter(x => !x.esDeHistorico_PortalTutor);
			practicas.forEach(e => {
				state.asignaciones.push(e);
			});
		},
		setDocumentos: function (state, data) {
			state.documentos = data;
		},
		changePracticaStatus: function (state, data) {
			state.validaciones.forEach(e => {
				if (e.idPractica == data.idPractica) {
					e.idEstadoValidacion = data.idEstado;
				}
			});
		},
		changePracticaAsignacionStatus: function (state, data) {
			state.asignaciones.forEach(e => {
				if (e.idPractica == data.idPractica) {

					e.idTutorAcademico = data.idTutor;

					//Si se la ha asignado a si mismo le pongo la práctica en el listado de validaciones
					if(state.totales.idTutor==data.idTutor){
						state.tutoradas.push(e);
					}
				}
			});
		},
		changeEvaluacion: function (state, id) {
			state.tutoradas.forEach(e => {
				if (e.idPractica == id) {
					e.evaluadaPorTutor = !e.evaluadaPorTutor;
				}
			});
		},
		loading(state) {
			state.loading = true;
		},
		endLoad(state) {
			state.loading = false;
		},
		loadingHistorico(state) {
			state.loadingHistorico = true;
		},
		endLoadHistorico(state) {
			state.loadingHistorico = false;
		},

	}
}

export default errors;



// WEBPACK FOOTER //
// ./src/store/practicas.js